var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifyThunder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17958",
    "data-name": "Grupo 17958",
    transform: "translate(-1454 -231)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_86170",
    "data-name": "Rect\\xE1ngulo 86170",
    width: 42,
    height: 42,
    rx: 5,
    transform: "translate(1454 231)",
    fill: "#fff7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "electric_bolt_FILL1_wght400_GRAD0_opsz48",
    d: "M124.835,198.359l4.981-8.942L120,188.252,134.417,175h1.718l-4.981,8.942,9.815,1.165-14.417,13.252Z",
    transform: "translate(1345 65.32)",
    fill: "#f4a01b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifyThunder);
export default __webpack_public_path__ + "static/media/notify-thunder.49a506fa0e201e70077c93fae5d8350e.svg";
export { ForwardRef as ReactComponent };